import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "brain-payment-plan",
    templateUrl: "./payment-plan.component.html",
    styleUrls: ["./payment-plan.component.scss"]
})
export class PaymentPlanComponent implements OnInit {
  @Input()
  public payment: any;

  @Input()
  public paymentId: string;

  @Input()
  public productId: string;

  @Input()
  sku: string;

  loaded = false;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
      if (this.payment) {
          this.loaded = true;
      }
  }

  navigate(url: string): void {
      sessionStorage.setItem("plan", JSON.stringify(this.payment));
      this.router.navigate(["/" + url]);
  }
}
